import { Button, Dialog, ButtonType } from "@constellation-academy/epic-ui";
import { useTranslation } from "@i18n/hooks";
import { buttonsWrapperClass } from "./confirm-dialog.styles";
import { type ConfirmWithTextDialogProps } from "./confirm-dialog.types";
import { error100, shade0 } from "../../themes/colors";
import { ButtonVariant } from "../button";

export const ConfirmDialog = ({
	showDialog = true,
	setShowDialog,
	title,
	content,
	cancelButtonText,
	confirmButtonText,
	onCancel,
	onConfirm,
}: ConfirmWithTextDialogProps) => {
	const { t } = useTranslation("common");
	const cancelText = cancelButtonText ?? t("actions.cancel");
	const confirmText = confirmButtonText ?? t("actions.yes");
	const handleClose = () => {
		onCancel?.();
		setShowDialog?.(false);
	};

	const handleConfirm = () => {
		onConfirm?.();
		setShowDialog?.(false);
	};

	return (
		<Dialog
			visible={showDialog}
			onHide={handleClose}
			title={title}
			footerNode={
				<div className={buttonsWrapperClass}>
					<Button onClick={handleClose} type={ButtonType.Button} label={cancelText} />
					<Button
						type={ButtonType.Button}
						variant={ButtonVariant.Error}
						backgroundColor={error100}
						onClick={handleConfirm}
						contentColor={shade0}
						label={confirmText}
					/>
				</div>
			}
		>
			{content}
		</Dialog>
	);
};
